import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { url } from "../../Address/baseURL";
import { DataGrid } from "@mui/x-data-grid";
import Backbtn from "../../Components/Backbtn";
import { Message } from "@mui/icons-material";

function StockinmanualSelect() {
  const navigation = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    axios
      .post(url + "/admin/stock_list", {
        comp_id: +localStorage.getItem("comp_id"),
        item_id: 0,
      })
      .then((resp) => {
        console.log(resp);
        setItems(resp?.data?.msg || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        Message("error", "Failed to load items");
        setLoading(false);
      });
  }, []);

  const filteredItems = items.filter((item) => {
    const q = search.toLowerCase();
    return (
      item.item_name?.toLowerCase().includes(q) ||
      item.branch_name?.toLowerCase().includes(q)
    );
  });

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "item_name", headerName: "Item Name", flex: 1 },
    { field: "branch_name", headerName: "Branch", flex: 1 },
    {
      field: "stock",
      headerName: "Stock",
      type: "number",
      width: 120,
      renderCell: (params) => (
        <span
          style={{
            color: params.value > 0 ? "inherit" : "#ef4444",
            fontWeight: params.value > 0 ? "normal" : "bold",
          }}>
          {params.value ?? 0}
        </span>
      ),
    },
  ];

  const handleRowClick = (params) => {
    navigation(`/home/stock/stockinmanual/${params.row.id}/${params.row.br_id}`);
  };

  return (
    <>
      <Backbtn />
      <section className="bg-white dark:bg-gray-900">
        <div className="py-8 px-4 mx-auto max-w-4xl lg:py-16">
          <h2 className="mb-4 text-xl font-bold text-blue-900 dark:text-white">
            Select Item for Stock‑In
          </h2>

          {/* Search Input */}
          <div className="mb-4">
            <input
              type="text"
              id="item-search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search by item name or branch..."
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
            />
          </div>

          <div style={{ height: 500, width: "100%" }}>
            <DataGrid
              rows={filteredItems}
              columns={columns}
              getRowId={(row) => `${row.id}_${row.br_id}`}
              pageSize={10}
              rowsPerPageOptions={[10, 20, 50]}
              loading={loading}
              onRowClick={handleRowClick}
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default StockinmanualSelect;
